import { HttpClient } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpOptions, HttpService } from './../../utils';
import { li } from './../services/logger/logger.service';

/* Copyright IBM Corp. 2017 */
const LOGGER = 'HttpServiceOnHttpClient';

export const HTTP_SERVICE_ON_HTTP_CLIENT = new InjectionToken<HttpService>(LOGGER);

/**
 * Implements the {@link HttpService} interface on top of the {@link HttpClient} interface.
 *
 * @param aHttp     the client
 * @return service implementation
 */
export function createHttpServiceOnHttpClient(aHttp: HttpClient): HttpService {

    /**
     * Implementation of the getter function
     *
     * @param aUrl  the URL
     * @param aOptions  the options
     *
     * @return the observable
     */
    function _getText(aUrl: string, aOptions: HttpOptions): Observable<string> {
        // send the request
        li(LOGGER, 'getText', aUrl, aOptions);
        return aHttp.get(aUrl, {
            withCredentials: aOptions.withCredentials,
            responseType: 'text'
        });
    }

    /**
     * Implementation of the getter function
     *
     * @param aUrl  the URL
     * @param aOptions  the options
     *
     * @return the observable
     */
    function _getJson<T>(aUrl: string, aOptions: HttpOptions): Observable<T> {
        // send the request
        li(LOGGER, 'getJson', aUrl, aOptions);
        return aHttp.get<T>(aUrl, {
            withCredentials: aOptions.withCredentials,
            responseType: 'json'
        });
    }

    // returns the service wrapper
    return {
        'getJson': _getJson,
        'getText': _getText
    };
}
